module.exports = __webpack_public_path__ + "img/douyin1.9b13abf0.png";